import { jsx as m } from "react/jsx-runtime";
import { Heading as t } from "@chakra-ui/react";
import { ThemeFontVariable as d, ThemeFontSizeVariable as g, ThemeColorVariable as l } from "../../theme/theme-types.js";
function p({
  color: e = l.OnBackground,
  fontSize: r = g.XLarge,
  fontWeight: o = "bold",
  children: a,
  fontFamily: i = d.Header,
  ...n
}) {
  return /* @__PURE__ */ m(
    t,
    {
      color: e,
      fontSize: r,
      fontFamily: i,
      fontWeight: o,
      role: "heading",
      ...n,
      children: a
    }
  );
}
export {
  p as Heading
};
